<template lang="html">
    <div v-bind:class="{'z-dialog': true, 'showed': showed}" v-if="display">
        <div class="z-dialog__shadow"></div>
        <div v-bind:class="{'z-dialog__window': true, 'showed': showed}" v-click-outside="close">
            <div class="z-dialog__window__title">
                <slot name="title"></slot>
            </div>
            <div class="z-dialog__window__content">
                <slot name="default"></slot>
            </div>
            <div class="z-dialog__window__actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'z-dialog',
        components: {},
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                display: false,
                showed:  false
            }
        },
        created() {},
        watch: {
            '$props.active'() {
                this.toggleView()
            }
        },
        computed: {},
        methods: {
            close() {
                this.$emit('update:active', false)
                this.$emit('close')
            },
            toggleView() {
                if (this.$props.active) {
                    this.display = true;
                    setTimeout(() => this.showed = true, 10);
                } else {
                    this.showed = false;
                    setTimeout(() => this.display = false, 360);
                }
            }
        }
    }
</script>
<style lang="sass">
    .z-dialog
        display: flex
        align-items: center
        justify-content: center
        position: fixed
        width: 100vw
        height: 100vh
        z-index: 100
        top: 0
        left: 0
        background: rgba(0,0,0,.6)
        transition: .35s cubic-bezier(.4,0,.2,1)
        opacity: 0
        &.showed
            opacity: 1
        .z-dialog__window
            display: flex
            flex-direction: column
            background-color: var(--color-secondary-100)
            box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)
            min-width: 280px
            max-width: 80%
            max-height: 80%
            border-radius: var(--border-radius-x1)
            padding: var(--padding-x3)
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%) scale(0)
            transition: .15s cubic-bezier(.25,.8,.25,1), transform .2s cubic-bezier(.25,.8,.25,1), -webkit-transform .2s cubic-bezier(.25,.8,.25,1)
            &.showed
                top: 50%
                left: 50%
                transform: translate(-50%, -50%) scale(1)
        .z-dialog__window__title
            margin: 0 0 var(--margin-x2) 0
            text-align: center
        .z-dialog__window__content
        .z-dialog__window__actions
            display: flex
            align-items: center
            justify-content: flex-start
            margin: 0 calc(var(--margin-x1) * -1)
</style>


// WEBPACK FOOTER //
// ZDialog.vue?33621713